import development from './development';
import production from './production';
import uat from './uat';
import stage from './stage';

const env = process.env.DEPLOY_ENV || 'development';

const config = {
  production,
  uat,
  stage,
  development
};

export default config[env];
